module.exports = __webpack_public_path__ + "assets/img/station12.ae77132f.png";